import { useEffect, useRef, useState } from 'react';

const API = 'https://randevuapi.uzmdrzelihaaksoy.com';

const log = (...args) => console.log('[SSE]', ...args);
const warn = (...args) => console.warn('[SSE]', ...args);

export function useSSE() {
  const esRef = useRef(null);
  const retryCount = useRef(0);
  const [authTick, setAuthTick] = useState(0);

  // Login/logout sayfa yenilemeden localStorage'a yazıyor; bu event olmadan
  // useEffect bir daha çalışmaz ve giriş yaptıktan sonra bile bağlantı hiç
  // kurulmazdı (yalnızca sayfa yenilenince fark edilirdi).
  useEffect(() => {
    function handleAuthChange() {
      setAuthTick(tick => tick + 1);
    }
    window.addEventListener('auth-changed', handleAuthChange);
    window.addEventListener('storage', handleAuthChange);
    return () => {
      window.removeEventListener('auth-changed', handleAuthChange);
      window.removeEventListener('storage', handleAuthChange);
    };
  }, []);

  useEffect(() => {
    const auth = localStorage.getItem('auth');
    if (!auth) {
      warn('auth bulunamadı, bağlantı kurulmadı');
      return;
    }

    const url = `${API}/api/events?auth=${encodeURIComponent(auth)}`;
    log('Bağlanıyor →', url);

    const es = new EventSource(url);
    esRef.current = es;

    es.onopen = () => {
      retryCount.current = 0;
      log('Bağlantı kuruldu ✓ (readyState:', es.readyState, ')');
    };

    // Backend named SSE event'leri gönderiyor (event: <tip>\ndata: ...), bu yüzden
    // onmessage değil, her tip için addEventListener kullanılıyor.
    function handleNamedEvent(type) {
      return (e) => {
        log(`"${type}" event alındı →`, e.data);
        let parsed = {};
        try {
          parsed = e.data ? JSON.parse(e.data) : {};
        } catch (err) {
          warn('Event parse hatası:', err.message, '| Ham veri:', e.data);
          return;
        }

        // Class component'ler için window event
        const detail = { type, ...parsed };
        window.dispatchEvent(new CustomEvent('sse', { detail }));
        log('window "sse" event dispatch edildi →', detail);
      };
    }

    es.addEventListener('connected', handleNamedEvent('connected'));
    es.addEventListener('ping', handleNamedEvent('ping'));
    es.addEventListener('randevu-olusturuldu', handleNamedEvent('randevu-olusturuldu'));
    es.addEventListener('randevu-guncellendi', handleNamedEvent('randevu-guncellendi'));
    es.addEventListener('randevu-silindi', handleNamedEvent('randevu-silindi'));

    es.onerror = (e) => {
      retryCount.current += 1;
      warn(
        'Bağlantı hatası (deneme #' + retryCount.current + ')',
        '| readyState:', es.readyState,
        // readyState: 0=CONNECTING, 1=OPEN, 2=CLOSED
        '(' + ['CONNECTING', 'OPEN', 'CLOSED'][es.readyState] + ')',
        e
      );
      if (es.readyState === EventSource.CLOSED) {
        warn('Bağlantı kapandı, EventSource yeniden bağlanmayı deneyecek');
      }
    };

    return () => {
      log('Bağlantı kapatılıyor');
      es.close();
    };
  }, [authTick]);
}
